module.exports = __webpack_public_path__ + "img/slide-17_low.d20ffd7d.png";